import React from 'react';
import { useInit } from '../../../Contexts/InitProvider';
import ReloadButton from '../../../features/ReloadButton/ReloadButton';
import PageTitle from '../../../utils/PageTitle';
import AddressTypes from './Components/AddressTypes';
import CustomerTypeList from './Components/CustomerTypeList';

function StaticDataPageHeader() {
    return (
        <div className="w-full flex items-center justify-end">
            <ReloadButton height="h-10" width="w-10" />
        </div>
    );
}

function StaticDataPage() {
    const { initInfo } = useInit();

    // set page title
    PageTitle(`Static`);

    return (
        <div className="setting-static inner_page_cont">
            <StaticDataPageHeader />
            <div className="flex flex-col gap-6">
                <CustomerTypeList data={initInfo?.roles} />
                <AddressTypes data={initInfo?.addressTypes} />
            </div>
        </div>
    );
}

export default StaticDataPage;
